<template>
    <div class="w-full text-xs">
        Password cannot be common and must be at least 8 characters in length.
    </div>
</template>

<script setup></script>